import { useEffect, useState } from "react";
import { Card, CardContent } from "./ui/card";

type Service = {
  image: string;
  title: string;
  description: string;
};

type ServiceType = Service[];

export default function ServicesList({ services }: { services: ServiceType }) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % services.length);
    }, 2000); // 2 seconds per card

    return () => clearInterval(interval);
  }, [services.length]);

  return (
    <div className="space-y-4">
      {services.slice(0, 3).map((service, index) => {
        const isActive = index === activeIndex;

        return (
          <Card
            key={index}
            className={
              `group cursor-pointer overflow-hidden rounded-sm border border-gray-200 bg-white/90 shadow-sm transition-all duration-500 hover:-translate-y-1 hover:border-cyan-400 hover:shadow-lg hover:shadow-cyan-900/10 ` +
              (isActive
                ? "translate-x-2 border-cyan-500 shadow-md shadow-cyan-900/10"
                : "")
            }
          >
            <CardContent className="p-4">
              <div className="flex items-start space-x-3">
                <div className="w-28 h-24 flex items-center justify-center shrink-0 overflow-hidden bg-cyan-50 transition-all duration-300">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg font-semibold text-gray-900 mb-1 line-clamp-1 transition-colors duration-300 group-hover:text-cyan-700">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed transition-colors duration-300 line-clamp-3 group-hover:text-gray-700">
                    {service.description}
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
